export default __webpack_public_path__ + "static/Screen Shot 2021-12-02 at 19.30.52-4c36878d6cf3798bb5bfef7ae5f5bc9e.png";